import React from "react";
import PropTypes from "prop-types";
import { Autocomplete, Box, Button, Grid, MenuItem, TextField, Typography } from "@mui/material";
import { AddBusiness, Refresh, Storefront } from "@mui/icons-material";
export default function HeaderCommerce({
  onRefresh,
  onCreateClick,
  loading,
  filtros,
  onFiltroChange,
  onClearFilters,
  tiposComercio,
}) {
  return (
    <Box sx={{ bgcolor: "#fff", border: "1px solid #dce5ed", borderRadius: 3, overflow: "hidden" }}>
      <Box
        sx={{
          p: 2.5,
          background: "linear-gradient(110deg, #193d50 0%, #176b71 100%)",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          flexWrap: "wrap",
        }}
      >
        <Storefront />
        <Box sx={{ flex: 1, minWidth: 180 }}>
          <Typography variant="h5" sx={{ color: "#fff", fontWeight: 700 }}>
            Comercios de Jarvis
          </Typography>
          <Typography sx={{ fontSize: 13, color: "#d6e5ee" }}>
            Configuración del comercio, integración y apertura CB
          </Typography>
        </Box>
        <Button
          startIcon={<Refresh />}
          disabled={loading}
          onClick={onRefresh}
          sx={{ "&&": { color: "#fff", border: "1px solid #8da9bd" } }}
        >
          Actualizar
        </Button>
        <Button
          startIcon={<AddBusiness />}
          disabled={loading}
          onClick={onCreateClick}
          sx={{
            "&&": { color: "#193d50", bgcolor: "#e3f2ed" },
            "&&:hover": { bgcolor: "#cce7dd" },
          }}
        >
          Agregar comercio
        </Button>
      </Box>
      <Grid
        container
        spacing={2}
        sx={{
          p: 2.5,
          "& .MuiInputBase-root": { minHeight: 54, color: "#244258", fontSize: 14 },
          "& .MuiInputLabel-root": { color: "#506b80" },
          "& .MuiSelect-icon": { display: "block", color: "#59748a" },
        }}
      >
        <Grid item xs={12} md={5}>
          <TextField
            fullWidth
            label="Buscar comercio, ID o integración"
            value={filtros.busqueda}
            onChange={(e) => onFiltroChange("busqueda", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            select
            label="Estado del comercio"
            value={filtros.activo}
            onChange={(e) => onFiltroChange("activo", e.target.value)}
          >
            {[
              ["todos", "Todos"],
              ["activos", "Activos"],
              ["inactivos", "Inactivos"],
              ["desconocidos", "Sin información"],
            ].map(([value, label]) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Autocomplete
            options={tiposComercio}
            value={filtros.tipo === "todos" ? null : filtros.tipo}
            onChange={(_, value) => onFiltroChange("tipo", value || "todos")}
            renderInput={(params) => (
              <TextField {...params} label="Tipo de comercio" placeholder="Todos los tipos" />
            )}
          />
        </Grid>
        <Grid item xs={12} md={1} sx={{ display: "flex", alignItems: "center" }}>
          <Button onClick={onClearFilters} sx={{ "&&": { color: "#245e89" } }}>
            Limpiar
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
HeaderCommerce.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  onCreateClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  filtros: PropTypes.object.isRequired,
  onFiltroChange: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
  tiposComercio: PropTypes.array.isRequired,
};
